import z from "zod";

import { type ErrorDetails, RemiHttpCode } from "./remi-app";

const inspectifyIntegrationErrorTypeValues = [
  "WEBHOOK_HEADER_MISSING",
  "WEBHOOK_SIGNATURE_INVALID",
  "WEBHOOK_TIMESTAMP_STALE",
] as const;
const inspectifyIntegrationErrorTypeSchema = z.enum(inspectifyIntegrationErrorTypeValues);
const InspectifyIntegrationErrorType = inspectifyIntegrationErrorTypeSchema.enum;
type InspectifyIntegrationErrorType = z.infer<typeof inspectifyIntegrationErrorTypeSchema>;

export type InspectifyIntegrationErrors =
  | {
      errorType: typeof InspectifyIntegrationErrorType.WEBHOOK_HEADER_MISSING;
      data: { header: string };
    }
  | {
      errorType: typeof InspectifyIntegrationErrorType.WEBHOOK_SIGNATURE_INVALID;
      data: undefined;
    }
  | {
      errorType: typeof InspectifyIntegrationErrorType.WEBHOOK_TIMESTAMP_STALE;
      data: undefined;
    };

export const inspectifyIntegrationErrorDetails: Record<InspectifyIntegrationErrorType, ErrorDetails> = {
  [InspectifyIntegrationErrorType.WEBHOOK_HEADER_MISSING]: {
    sentryDescription: "Required Svix webhook header is missing",
    remiHttpCode: RemiHttpCode.BAD_REQUEST,
  },
  [InspectifyIntegrationErrorType.WEBHOOK_SIGNATURE_INVALID]: {
    sentryDescription: "Svix webhook signature verification failed",
    remiHttpCode: RemiHttpCode.UNAUTHORIZED,
  },
  [InspectifyIntegrationErrorType.WEBHOOK_TIMESTAMP_STALE]: {
    sentryDescription: "Svix webhook rejected: timestamp outside the tolerance window (stale or replayed delivery)",
    remiHttpCode: RemiHttpCode.UNAUTHORIZED,
  },
};
